var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"my-2",attrs:{"src":require("@/assets/img/s2s-new-logo.png"),"height":"100","alt":"logo"}})])
}]

export { render, staticRenderFns }